let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2PUw9")).then(() => parcelRequire('6hgg7'));